export const tempConstants = {
    SERVICE_BY_ADDRESS_INTERVAL: 'SERVICE_BY_ADDRESS_INTERVAL',
    CAR_LOCATION_INTERVAL: 'CAR_LOCATION_INTERVAL',
    SERVICE_BY_ADDRESS_SAVE: 'SERVICE_BY_ADDRESS_SAVE',
    SERVICE_BY_ADDRESS_DROPOFF_SAVE: 'SERVICE_BY_ADDRESS_DROPOFF_SAVE',
};